import { Controller } from "@hotwired/stimulus";
import SignaturePad from "signature_pad";

// Connects to data-controller="onboardings"
export default class extends Controller {
  static targets = ["signaturePadCanvas", "signatureInput"];

  initialize() {
    this.canvas = document.querySelector("canvas#signature-pad-canvas");
    this.signaturePad = new SignaturePad(this.canvas);

    window.addEventListener("resize", this.resizeCanvas.bind(this));
    this.resizeCanvas();

    this.signaturePad.addEventListener("endStroke", () => {
      this.setSignatureFormField();
    });

    this.signaturePad.addEventListener("beginStroke", () => {
      this.resetSignaturePad();
    });

    this.signatureInputTarget.addEventListener("input", () => {
      this.generateSignature();
    });

    (async () => {
      await document.fonts.load("36px HandWritingOne");
      this.generateSignature();
    })();
  }

  resetSignaturePad() {
    // reset is this is the first stroke
    if (this.firstStroke) {
      // clear() here would drop the pad's hold on the stroke now starting, so
      // wipe just the pixels of the generated name
      this.canvas
        .getContext("2d")
        .clearRect(0, 0, this.canvas.width, this.canvas.height);
      this.firstStroke = false;
    }
  }

  setSignatureFormField() {
    this.formField = document.querySelector(
      "input#super_fund_choice_signature_encoded",
    );
    this.formField.value = this.signaturePad.toDataURL();
  }

  clearSignaturePad() {
    this.signaturePad.clear();
  }

  resizeCanvas() {
    const savedData = this.signaturePad.toDataURL();
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.canvas.width = this.canvas.offsetWidth * ratio;
    this.canvas.height = this.canvas.offsetHeight * ratio;
    this.canvas.getContext("2d").scale(ratio, ratio);
    this.signaturePad.fromDataURL(savedData);
  }

  generateSignature() {
    this.firstStroke = true;
    this.clearSignaturePad();
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    this.ctx = this.canvas.getContext("2d");
    this.ctx.font = "36px HandWritingOne";
    this.ctx.textAlign = "center";
    this.ctx.textBaseline = "middle";
    this.ctx.fillText(
      this.signatureInputTarget.value,
      this.canvas.width / ratio / 2.2,
      this.canvas.height / ratio / 2,
    );
    this.setSignatureFormField();
  }
}
